'use strict';



document.DEV_MODE = true;
document.app = {};
document.app.devmode = {};
document.app.dadata = {};

import { GDRPCls } from "./GDRP/main.js";
import { PopupWindow } from "./PopUp/main.js";
import { WebFormCls } from "./WebForm/main.js";
import { _Amount } from "./Amount/main.js";
import { uxCookie } from "../Libs/Cookie/main.js";
//import { Recent } from "./Catalog/Recent/main.js";
//import { getOffer } from "./Catalog/PDF/main.js";
//import { BasketForm } from "./Basket/main.js";

import { uxRequest } from "Libs/Request/main.js";

import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

document.isReady = false;



let isDef = (name) => typeof name == 'undefined' ? false : true;

//---- Add Document Events ----

document.ready = new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));

document.ready.then(() => {
	document.isReady = true;
	


// FILTER BLOCK SHOW/HIDE
	const header = document.querySelector('.filter-header');
    const body = document.querySelector('.filter-body');

    if (header && body) {
    
	    header.addEventListener('click', () => {
	      if (body.style.height === '0px' || !body.style.height) {
	        // Expand
	        //body.style.height = `${body.scrollHeight}px`;
	        body.style.height = `auto`;
	      } else {
	        // Collapse
	        body.style.height = '0';
	      }
	    });
    }
// END FILTER


    



uxRequest({
					'url': '/sites/sps/assets/webform.html'
				}).then(
					(html_text) => {
						//console.log(html_text);
						//let doc = parser.parseFromString(html_text.response, "text/html");
						//document.querySelector('#test').appendChild(doc);						
						//document.querySelector('#test').innerHTML = html_text.response;					
					}			
				).catch((err) => {
					console.log("request error");
				});



				//--------------------




	
	const lightbox = GLightbox();






	let elem = document.querySelector('.masonry-grid');

	if (elem) {
		let  msnry = new Masonry( elem, {
		  	itemSelector: '.masonry-grid-item',
  			columnWidth: '.masonry-grid-sizer',
  			percentPosition: true
		});

		imagesLoaded( elem ).on( 'progress', function() {
  			// layout Masonry after each image loads
  			msnry.layout();
		});
	}



	
});



/*
const images = document.querySelector('.image-gallery');
if (images) {
	//main image
	const mainA = images.querySelector('.image');
	mainA.dataset.orig = mainA.href;

	const mainImg = mainA.querySelector('img');
	mainImg.dataset.orig = mainImg.src;

	const gallery = images.querySelector('.thumbs-gallery');

	let timer;

	if (gallery) {

		gallery.addEventListener('mouseover', (e) => {
			clearTimeout(timer);

			const target = e.target;
			let a;
			let img;

			if (target.tagName == 'A') {
				a = target;
				img = target.querySelector('img');
			}

			if (target.tagName == 'IMG') {
				img = target;
				a = target.closest('a.image');				
			}

			if (a && img) {
				mainA.href = a.href;
				mainImg.src = img.dataset.full;
			}			
		})

		gallery.addEventListener('mouseout', (e) => {
						

				timer = setTimeout((() => {
					mainA.href = mainA.dataset.orig;
					mainImg.src = mainImg.dataset.orig;
				}), 100);
		})
	}

	


}
*/

document.addEventListener('DOMContentLoaded', function(){
	/*

	new Hamburger();

	const orderButtons = document.querySelectorAll('.order-button');
	if (orderButtons.length > 0) {
		orderButtons.forEach((item) => {
			item.addEventListener('click', (e) => {
				PopupWindow.show();
				WebForm.setHeader('Некие автоматически добавленные сведения о товаре');
				WebForm.reset();
			})
		})
	}

	*/

	/* Tabs */

	// Select all tab links and tab content elements
const tabLinks = document.querySelectorAll('.tab-link');
const tabContents = document.querySelectorAll('.tab-content');

if ((tabLinks.length > 0) && (tabContents.length > 0)) {
	// Loop through each tab link and add a click event listener
tabLinks.forEach(link => {
    link.addEventListener('click', () => {
        // Remove 'active' class from all tab links and tab contents
        tabLinks.forEach(tab => tab.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));

        // Add 'active' class to the clicked tab and its corresponding content
        link.classList.add('active');
        document.getElementById(link.getAttribute('data-tab')).classList.add('active');
        window.location.hash = link.getAttribute('data-tab');
    });
});
}

let urlHash = window.location.hash;

if (urlHash.length > 2) {
	urlHash = urlHash.substring(1);

			const tabItem = document.querySelector(`.tabs button[data-tab = '${urlHash}']`);

			if (tabItem) {
				tabItem.dispatchEvent(new Event('click'));
			}

	}		

			
const xData = document.querySelectorAll('p.x-data a');

if (xData.length > 0) {
	xData.forEach((a) => {
		const tabId = a.dataset.tab;

		const tabItem = document.querySelector(`.tabs button[data-tab = '${tabId}']`);

			if (tabItem) {

				a.addEventListener('click', (e) => {
					e.preventDefault();
					tabItem.dispatchEvent(new Event('click'));

				})

				
			}

	})
}	
	
/*  Tabs end */




	let homeSlider = document.querySelector('#home-slider');
	if (homeSlider) {

		const lang = 'ru';

		const homeSliderDataAllLangs = {};

		homeSliderDataAllLangs['ru'] = [
			/*'/goods/industrial-x-ray-films/kodak.html',*/
			'/goods/industrial-x-ray-films/aike.html',
/* '/goods/industrial-x-ray-films/ndtquam-ht400.html',*/


'/goods/rentgenotelevizionnye-sistemy.html',
'/goods/prinadlezhnosti/negatoskop.html',
];



		const homeSliderData = homeSliderDataAllLangs[lang];


const homeSliderButtons = [];
const homeSliderImages = [];


class SliderItem {
	constructor() {
		
	}
}


let nextIterator = 0;

		const homeSliderButtonsContainer = document.querySelector('#home-slider-buttons');
		

			let fragment = document.createDocumentFragment();

			homeSliderData.forEach((item) => {

				const li = document.createElement('li');
				
				const a = document.createElement('a');
				a.setAttribute('href', item);
				a.classList.add(`lang-${lang}`);
				li.appendChild(a);
				fragment.appendChild(li);
				homeSliderImages.push(li);

				/*

				const li2 = document.createElement('li');
				
				const a2 = document.createElement('a');
				a2.setAttribute('href', item);
				a2.classList.add(`lang-${lang}`);
				li2.appendChild(a2);
				fragment.appendChild(li2);
				homeSliderImages.push(li2);

				*/
			});

			homeSlider.appendChild(fragment);

			fragment = document.createDocumentFragment();

			homeSliderData.forEach((item, key) => {
				const div = document.createElement('span');
				homeSliderButtons.push(div);
				div.dataset.key = parseInt(homeSliderButtons.length - 1);


				div.addEventListener('click', (e) => {
					e.stopImmediatePropagation();
					let key = e.target.dataset.key;
					nextIterator = key;
					forceChange();
				})

				fragment.appendChild(div);
				
/*
				const div2 = document.createElement('span');
				homeSliderButtons.push(div2);
				div2.dataset.key = parseInt(homeSliderButtons.length - 1);

				div2.addEventListener('click', (e) => {
					e.stopImmediatePropagation();
					let key = e.target.dataset.key;
					nextIterator = key;
					forceChange();
				})

				fragment.appendChild(div2);
*/				
			});

			homeSliderButtonsContainer.appendChild(fragment);

	
		let rndStart = {
			'ru': [4,6,2,0],
			'en': [0],
		}


		rndStart = rndStart[lang];
		//let i = parseInt(rndStart[Math.floor(Math.random() * rndStart.length)]);
		let i = 0;

		//let lastI = getCookie('slider');
		let lastI = 0;

		if (lastI !== undefined) {

			lastI = parseInt(lastI);

			console.log('i', i, lastI);

			/*
			if (i == lastI) {
console.log('i56', i, lastI);

			do {
				
				i = parseInt(rndStart[Math.floor(Math.random() * rndStart.length)]);
				console.log('i55', i, lastI);

			} while (i == lastI) 
			
			}
			*/
		}



console.log("i2:", i);

		//setCookie('slider', i, {'max-age': 3600});

		
		

		//let i = 2;//
		//let frames = homeSlider.querySelectorAll('li');
		//let homeSliderImages = homeSliderImages;
		let framesLength = homeSliderImages.length;

		//setup
		let firstSlide = homeSliderImages[i];		
		homeSliderImages.forEach((item) => {item.classList.add('unselect')});
		//firstSlide.style.opacity = 1;		
		firstSlide.classList.remove('unselect');
		firstSlide.classList.add('select');

		let firstButtom = homeSliderButtons[i];		
		homeSliderButtons.forEach((item) => {item.classList.add('unselect')});
		//firstSlide.style.opacity = 1;		
		firstButtom.classList.remove('unselect');
		firstButtom.classList.add('select');
		
		function getNextIterator() {
			if (nextIterator) {
				i = nextIterator;
				nextIterator = 0;
			}
			else {
				i++;
				if (i == framesLength) i = 0;
			}
			

			return i;
		}


		

		function getNextFrame() {
			i++;
			if (i == framesLength) i = 0;

			return homeSliderImages[i];
		}

		function changeSlide() {
			let cf = homeSliderImages[i];
			let cb = homeSliderButtons[i];

			i = getNextIterator();

			let nf = homeSliderImages[i];
			let nb = homeSliderButtons[i];

			cf.classList.remove('select');
			cf.classList.add('unselect');
			nf.classList.add('select');
			nf.classList.remove('unselect');

			cb.classList.remove('select');
			cb.classList.add('unselect');
			nb.classList.add('select');
			nb.classList.remove('unselect');

		}

		function forceChange() {
			clearTimeout(timer1);
			clearInterval(timer2);
			changeSlide();
			timers(i);
		}


		let timer1, timer2;

		function timers(i) {
			timer1 = setTimeout(((i) => {//start slider
				changeSlide();

				timer2 = setInterval(((i) => {
					changeSlide();
				}).bind(null), 6000);
			}).bind(null), 4000);
		}

		timers(i);


		

		
	}
	

});


/*
class Hamburger {
	constructor() {		
		let container = document.querySelector('#menu-hamburger');
		let icon = document.querySelector('#menu-hamburger-icon');
		
		icon.addEventListener('click', (event) => {
			container.classList.toggle('checked');
			icon.classList.toggle('checked');
		});
		
		container.addEventListener('click', (event) => {
			let target = event.target;
			if (target.nodeName == 'SPAN' || target.nodeName == 'LI') {
				container.classList.toggle('checked');
				icon.classList.toggle('checked');
			}
		});		
	}	
}
*/


document.addEventListener('DOMContentLoaded', function(){
	//new Hamburger();

	let WebForm = new WebFormCls(PopupWindow, {
		'pageId': document.body.dataset.pageId,
		'agreeText':`(*) Нажимая кнопку «Отправить», я даю своё cогласие на сбор и обработку моих персональных данных в соответствии с <a href="/legal/private_information_policy.html" target="_blank" >Политикой конфиденциальности</a>`,
		'welcomeText': 'Пожалуйста, укажите контактные данные, чтобы мы могли с вами связаться.' + "\r\n" + 'Мы работаем с 10:00 до 17:00 по московскому времени; если вы в другом часовом поясе, напишите нам об этом, чтобы мы не беспокоили вас в ваше нерабочее время.'
	});

	const orderButtons = document.querySelectorAll('.js-popup-webform');
	if (orderButtons.length > 0) {
		orderButtons.forEach((item) => {
			item.addEventListener('click', (e) => {
				PopupWindow.show();
				//WebForm.setHeader('Некие автоматически добавленные сведения о товаре');



				WebForm.reset();
				WebForm.setContent('');
			})
		})
	}

	let GDRP = new GDRPCls({'timeOutInDays': 0,
    	'text': `<p>Этот сайт использует файлы cookie и собирает статистику посещения и данные посетителей с помощью сервиса Яндекс.Метрика. Продолжая работу с сайтом, вы подтверждаете согласие со сбором статистики и использованием сооkiеѕ.</p>
        <p>Обработка данных пользователей осуществляется в соответствии с <a href="/legal/private_information_policy.html" target="_blank">Политикой конфиденциальности</a>.</p>`,
		'timeOutInDays': 30});


	



const Items = new Map();
let _allItemsAmount = 0;

	const ItemsCollection = document.querySelectorAll('.js-available-item');

	//console.log(ItemsCollection.length)

	
	if (ItemsCollection.length > 0) {



		const allButtons = document.querySelectorAll('.js-order-form-item');
		const allButton = document.querySelector('#js-order-form-item-order-all');

	
		

		ItemsCollection.forEach((item) => {
			

			let oItem = new Object();
			let blk = item.querySelector('.js-order-block-item-table');
			oItem.name = blk.dataset.name;
			let id = blk.dataset.id;
			//console.log('item-name', oItem.name);

			oItem.orderButton = item.querySelector('.js-order-form-item-order');
			oItem.amount = new _Amount({
				'container': item.querySelector('.js-amount'),
				'callback': {
					'calculate': (value) => {

						_allItemsAmount = 0;

						if (value > 0) {
							oItem.orderButton.classList.remove('blocked');

						} else {
							oItem.orderButton.classList.add('blocked');
						}

						Items.forEach((iteratedItem) => {
							_allItemsAmount = _allItemsAmount + iteratedItem.amount.value;
						})

						if (allButton) {
							if (_allItemsAmount > 0) {
							allButton.classList.remove('blocked');
						} else {
							allButton.classList.add('blocked');
						}
						}

						
					}
				}
			});


			Items.set(id, oItem);
		})


		
	}

	//console.log(Items);





	const orderButtons2 = document.querySelectorAll('.js-order-form-item');
	if (orderButtons2.length > 0) {
		orderButtons2.forEach((item) => {
			item.addEventListener('click', (e) => {
				PopupWindow.show();
				WebForm.reset();

				let text = '';


				let buttonType = item.dataset.name;
				let id = item.dataset.id;

				if (buttonType == 'order') {

					if (_allItemsAmount > 0) {
						text += "\r\n------\r\n" + "Заказ:" + "\r\n";

						Items.forEach((iteratedItem) => {
							if (iteratedItem.amount.value > 0) {
								text += iteratedItem.name + ' (' + iteratedItem.amount.value + " шт) \r\n";
							}
							
						})

						

					}
				} 

				if (buttonType == 'question') {
					text += "\r\n------\r\n" + "Обращение по товару:" + "\r\n";

					text += Items.get(id).name + " \r\n";
						
				}
				
				WebForm.setContent(text);
						
					
				

				
				
				
			})
		})
	}





});




window.YandexSmartCaptchaKey = 'ysc1_S7a5S4ycTZbeL7Gd6ozFfuIkdLbyZJHTdBn3fKwmc9b565f6';


window.YandexSmartCaptcha = function() {
	console.log('rrr');

	document.addEventListener('DOMContentLoaded', function(){
		if (!window.smartCaptcha) {
			console.error("no yandex captcha");
			return;
		}


		// получить все формы с контейнкером для каптчи

		//const Forms = [...document.querySelectorAll("[data-yandex-captcha]")].map(el => el.closest('form')).filter(element => element);
		const Forms = [...document.querySelectorAll("[data-yandex-captcha]:not([installed])")];

		console.log(Forms);


		Forms.forEach((captchaContainer) => {
			const form = captchaContainer.closest('form');

			if (form) {
				const captchaId = window.smartCaptcha.render(captchaContainer, {
					sitekey: window.YandexSmartCaptchaKey,
					invisible: true, // Сделать капчу невидимой,
					//test: true,
					h1: 'ru',
					callback: (token)=> {
						if (typeof token === "string" && token.length > 0) {
							form.submit();
					    }
					},
				});

				const captchaIdInput = document.createElement("input");
		        captchaIdInput.type = 'hidden';
		        captchaIdInput.name = "captcha-widget-id";
		        captchaIdInput.value = captchaId;

		        form.appendChild(captchaIdInput);


				form.addEventListener('submit', (event) => {
					event.preventDefault();

					if (!window.smartCaptcha) {
						console.error("no yandex captcha");
						return;
					}

					//const form = event.currentTarget;
			        const captchaId = form.querySelector('[name="captcha-widget-id"]').value;
			        window.smartCaptcha.execute(captchaId);
				})

			}
		})


		

		

	});
}





document.addEventListener('DOMContentLoaded', function() {

  let Nav = new hcOffcanvasNav('#main-nav', {
    disableAt: 880,
    navTitle: '',
    levelTitles: true,
    levelTitleAsBack: true,
    position: 'top',
    //pushContent: document.querySelector('#menu-phone-append'),
    bodyInsert: 'append'
  });



  let mobileWebForm = document.querySelector('.nav-item-wrapper .js-mobile-webform');

  if (mobileWebForm) {
  	

  	mobileWebForm.addEventListener('click', (event) => {

  		event.preventDefault();
  		event.stopImmediatePropagation();
  		Nav.close();
  		PopupWindow.show();
				//WebForm.setContent('Некие автоматически добавленные сведения о товаре');
				WebForm.reset();



  	})
  }


//заполняет коллекцию товаров
  const Items2 = new Map();

  //проверяем, что есть фильтры
  const filterBody = document.querySelectorAll('#filter-body ul li span');
 //проверяем, что есть товары
  const itemCardCollection = document.querySelectorAll(".catalog-items .item");

  if (filterBody && itemCardCollection) {
  	itemCardCollection.forEach((item) => {

		let oItem = new Object();
		let id = item.dataset.id;
		oItem.id = item.dataset.id;
		oItem.filter = item.dataset.filter;
		oItem.item = item;
		Items2.set(id, oItem);
	});
 


//фильтры независимые
  const ItemsFiltersCollection = document.querySelectorAll('#filter-body ul');

  ItemsFiltersCollection.forEach((ItemFilter) => {

  


  	const filterBody2 = ItemFilter.querySelectorAll('li span');


    		


	    	filterBody2.forEach(item => {
	    		item.addEventListener('click', () => {

	    			const needFiltered = [];

	    			

	
	    			if (item.classList.contains('active')) {
	    				item.classList.remove('active');

	    				filterBody.forEach(item2 => {
			    			if (item2.classList.contains('active')) needFiltered.push(item2.dataset.filter);
			    		});

console.log(needFiltered);

			    		//убрали последний фильтр. Показываем все
			    		if (needFiltered.length < 1) {
			    			Items2.forEach((iteratedItem) => {	    
									iteratedItem.item.style.display = 'flex';
							})
			    		} else {			    		
							Items2.forEach((iteratedItem) => {
								let itemFilter = [];

		    					needFiltered.forEach(filterValue => {
		    						if (iteratedItem.filter.includes(filterValue)) {
										itemFilter.push(true);
									} else {
										itemFilter.push(false);
									}
			    				})

		    					if (!itemFilter.includes(false)) {
									iteratedItem.item.style.display = 'flex';
								} else {
									iteratedItem.item.style.display = 'none';
								}

							})
						}

	    			} else {

	    				filterBody2.forEach(item => {
	    					item.classList.remove('active');
	    				})

	    				item.classList.add('active');

	    				filterBody.forEach(item2 => {
			    			if (item2.classList.contains('active')) needFiltered.push(item2.dataset.filter);
			    		});
console.log(needFiltered);
	    				Items2.forEach((iteratedItem) => {
								let itemFilter = [];

		    					needFiltered.forEach(filterValue => {
		    						if (iteratedItem.filter.includes(filterValue)) {
										itemFilter.push(true);
									} else {
										itemFilter.push(false);
									}
			    				})

		    					if (!itemFilter.includes(false)) {
									iteratedItem.item.style.display = 'flex';
								} else {
									iteratedItem.item.style.display = 'none';
								}

							})

	    				
	    			}
	    		})
	    	})

    	})
     } 
       

    






});
